import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SelectListTypeForCreation } from '../../communication-structure/select-list-type-for-creation';
import { SelectListTypeForEdit } from '../../communication-structure/select-list-type-for-edit';
import {
  TrainingsInAutoTrainingCodeFullModel, TrainingsInAutoTrainingCodeModel
} from '../../communication-structure/trainings-in-auto-training-code-list';
import { LoginService } from '../../services/login.service';
import { StringTableService } from '../../services/string-table.service';
import { AccordionComponent } from '../accordion/accordion.component';
import { EngineComponent } from '../engine/engine.component';
import { CommunicationProxyService } from './../../services/communication-proxy.service';
import { KeyCodes } from './../../services/keyboard.service';
import { BaseComponent } from './../base/base.component';
import { MainComponent } from './../main-component/main.component';
import { Table, Types } from '../table/table.component';
import { TaskAttemptList } from '../../communication-structure/task-attempt-list';
import { TaskListFullModel } from '../../communication-structure/taskList';
import { PieChartType } from '../pie-chart/pie-chart.component';
import { dialogTypeEnum } from '../modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-page-view',
  templateUrl: './page-view.component.html',
  styleUrls: ['./page-view.component.scss']
})
export class PageViewComponent extends BaseComponent {
  protected static imgList = [];
  @Input() id: number;
  @Input() activePageViewID: number;
  @Input() endPoints: any;
  @Input() parent;
  @Input() isDashboard = false;
  public dialogVisible = false;
  progressPopup = false;
  retryPopup = false;
  validationPopup = false;
  modalData: { title: string, body: string };
  dialogSuccessCallback: Function = null;
  validationString = '';
  protected accessIconPath: string;
  protected excelIconPath: string;
  protected wordIconPath: string;
  protected powerpointIconPath: string;
  protected outlookIconPath: string;
  exAssignmentId: any;
  accordionName: any;
  skillName: any;
  callback: any;
  protected getApplicantTrainingResultEndPoint: string;
  protected generatePdfReportEndPoint: string;
  protected skillResultEndPoint: string;
  protected getClientTrainingListEndPoint: string;
  private getATCListEndPoint: string;
  public header: Table[];
  protected attemptlist: TaskAttemptList[] = [];
  public displayedTable: Table[][];
  public displayedSubTableList: any[];
  public displayedSubTable: Table[][];
  public correctLabel: string;
  public inCorrectLabel: string;
  public incompleteLabel: string;
  public tableHeaderCols: string[] = [];
  protected linkStr: string;
  csvLogo: string;
  excelLogo: string;
  pdfLogo: string;
  excelDownloadingLogo: string;
  pdfDownloadingLogo: string;
  protected completeATCCount = 0;
  protected inprogressATCCount = 0;
  protected unattemptedATCCount = 0;
  // for pie chart on pop up
  itemValue: number = 0;
  pieChartType: number = PieChartType.UNATTEMPTED;
  /**
   * the Id of the client who is logged in.
   */
  protected currentUserClientID: string;

  /**
   * For “Web Based Testing” call.
   */
  protected systemID = 'OTG';

  public dialogType = dialogTypeEnum.default;

  /**if the user is on Windows only page then use this system Id.
   */
  protected windowsOnlySystemID = 'FTW';
  userName: string;
  userEmailId: string;
  protected noLoderFlag = false;
  public reviewCandidateId: string;

  constructor(
    ele: ElementRef,
    protected remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    protected stringTableService: StringTableService,
    protected router: Router

  ) {
    super(ele);
    this.id = -1;
    this.activePageViewID = -1;
    this.currentUserClientID = this.loginService.currentUserClientId;
    this.excelIconPath = this.stringTableService.getString('paths', 'excelLogo');
    this.accessIconPath = this.stringTableService.getString('paths', 'accessLogo');
    this.wordIconPath = this.stringTableService.getString('paths', 'wordLogo');
    this.csvLogo = this.stringTableService.getString('paths','csvLogo');
    this.excelLogo = this.stringTableService.getString('paths','excelLogo');
    this.pdfLogo = this.stringTableService.getString('paths', 'pdfLogo');
    this.excelDownloadingLogo = this.stringTableService.getString('paths', 'excelDownloadingLogo');
    this.pdfDownloadingLogo = this.stringTableService.getString('paths', 'pdfDownloadingLogo');
    this.powerpointIconPath = this.stringTableService.getString('paths', 'powerpointLogo');
    this.outlookIconPath = this.stringTableService.getString('paths', 'outlookLogo');
    this.linkStr = this.stringTableService.getString('popups', 'detailLabel');
    this.getApplicantTrainingResultEndPoint = this.stringTableService.getEndpoint('GetApplicantTrainingResult');
    this.getClientTrainingListEndPoint = this.stringTableService.getEndpoint('GetClientTrainingList');
    this.generatePdfReportEndPoint = this.stringTableService.getEndpoint('GeneratePdfReport');
    this.skillResultEndPoint = this.stringTableService.getEndpoint('SkillResult');
    this.getATCListEndPoint = this.stringTableService.getEndpoint('GetAutotrainingCodeList');
    this.displayedTable = [];
    this.displayedSubTable = [];
    this.displayedSubTableList = [];
    this.correctLabel = this.stringTableService.getString('report-courses', 'correct');
    this.inCorrectLabel = this.stringTableService.getString('report-courses', 'incorrect');
    this.incompleteLabel = this.stringTableService.getString('report-courses', 'incomplete');
  }

  /**
   * @param endPoint the endpoint wiich we want to get data from
   * @param data parameters to be sent to the server
   */
  getDataFromApi(endPoint: string, data): Observable<any> {
    if (!this.noLoderFlag) {
      this.showLoader();
    }
    return this.remoteProxy.read(endPoint, data);
  }

  /**@param endPoint the endPoint to which we want to post data to
   * @param data the data which is to be sent to the server
   */
  postDataToApi(endPoint: string, data) {
    this.showLoader();
    return this.remoteProxy.update(endPoint, data);
  }
  findIndexOfSkillInClientTrainingList(name) {
    let list = MainComponent.getTrainingList();
    for (let i = 0; i < list.length; i++) {
      if (list[i].skill === name) {
        return i;
      }
    }
    return -1;
  }
  getApplicationIconPath(application): string {
    let path = '';
    switch (application) {
      case 'Access':
      case 'Access19':
        path = this.accessIconPath;
        break;
      case 'Excel':
      case 'Excel19':
        path = this.excelIconPath;
        break;
      case 'Word':
      case 'Word19':
        path = this.wordIconPath;
        break;
      case 'Powerpoint':
      case 'PowerPoint':
      case 'PowerPoint19':
        path = this.powerpointIconPath;
        break;
      case 'Outlook':
      case 'Outlook19':
        path = this.outlookIconPath;
        break;
    }
    return path;
  }
  getHandeledAtcData() {
    return MainComponent.getAtcData();
  }
  calcAtcCompletionPerc(skillList): { itemValue: number, chartType: number } {
    let skillCompleteCount = 0;
    for (const skill of skillList) {
      if (skill.attempts > 0) {
        ++skillCompleteCount;
      }
    }
    const itemValue = skillCompleteCount / skillList.length;
    const chartData = {
      itemValue: itemValue,
      chartType: this.getPieChartType(itemValue)
    };
    return chartData;
  }
  getPieChartType(itemValue): number {
    let chartType = 0;
    if (itemValue === 0) {
      ++this.unattemptedATCCount;
      chartType = PieChartType.UNATTEMPTED;
    } else if (itemValue === 1) {
      ++this.completeATCCount;
      chartType = PieChartType.COMPLETED;
    } else if (itemValue > 0 && itemValue < 1) {
      ++this.inprogressATCCount;
      chartType = PieChartType.INPROGRESS;
    }
    return chartType;
  }
  getApplicantTrainingResult(applicationid, skillId, callback?: any) {
    this.skillName = skillId;
    this.accordionName = applicationid;
    this.callback = callback;
    this.getDataFromApi(this.getApplicantTrainingResultEndPoint, { applicationid: applicationid, skillId: skillId })
    .subscribe(
      this.handleApplicantTrainingResultData.bind(this, this.skillName),
      this.handleSubscriptionError.bind(this, this.getApplicantTrainingResult.bind(this), false)
    );
  }
  
  handleApplicantTrainingResultData(skillId, data) {
    this.hideLoader();
    this.fillDataInJson(data, skillId);
    if (this.header.length === 0) {
      this.fillHeader();
    }
    this.fillTable(this.attemptlist.length > 0 ? data.skillAttemptList[0].testSessionCode : "");
  }
  getAttemptList() {
    return this.attemptlist;
  }

  fillTable(testId) {
    let index = 0;
    const exportOptionIcons = {
      pdfLogo: this.pdfLogo,
      excelLogo: this.excelLogo,
      excelDownloadingLogo: this.excelDownloadingLogo,
      pdfDownloadingLogo: this.pdfDownloadingLogo
    };
    this.displayedTable = [];
    for (const attempt of this.attemptlist) {
      this.displayedTable.push(this.generateDisplayTable( ++index, testId, attempt, exportOptionIcons ));
      this.displayedSubTableList[ testId + "" + index ] = this.fillSubTable( attempt.taskList );
    }
    if (this.callback) {
      this.callback();
    }
  }

  generateDisplayTable( index, testId, attempt, exportOptions ) {
    return [
      new Table(Types.HIDDEN_ID, 'table-data', testId + '' + index),
      new Table(Types.TEXT, 'table-data', this.convertDateToDisplay(attempt.testDateTime)),
      new Table(Types.TEXT, 'table-data', attempt.totalItems),
      new Table(Types.TEXT, 'table-data', attempt.totalScore),
      new Table(Types.TEXT, 'table-data', this.convertTime(attempt.timeUsed, ':')),
      new Table(Types.TEXT, 'table-data', this.countCorrect(attempt.taskList)),
      new Table(Types.TEXT, 'table-data', this.countResponse(attempt.taskList, false)),
      new Table(Types.TEXT, 'table-data', this.countResponse(attempt.taskList, true)),
      new Table(Types.IMGLINK_IMGLINK, 'tg-arrow-up2', this.linkStr, ' ', exportOptions),
      new Table(Types.HIDDEN_ID, 'table-data', attempt.taskList),
      new Table(Types.HIDDEN_ID, 'table-data', attempt.hasClickStream)
    ];
  }

  fillSubTable(subTable) {
    let index = 0;
    this.displayedSubTable = [];
    for(const data of subTable) {
      this.displayedSubTable.push([
        new Table(Types.TEXT, 'table-data', ++index),
        new Table(Types.TEXT, 'table-data', data.taskName),
        new Table(Types.TEXT, 'table-data', this.setQueState(data.status)),
        new Table(Types.TEXT, 'table-data', this.convertTime(data.timeTaken, ':')),
        new Table(Types.MINMAX_LIST, 'tg-arrow-up2', data.clickstreams)
      ]);
    }
    return this.displayedSubTable;
  }

  setQueState(status) {
    let statesText: string;
    if (qstnResponseStatus.Correct === status || status === 4) {
      statesText = this.correctLabel;
    } else if (qstnResponseStatus.Skipped === status || qstnResponseStatus.Incomplete === status) {
      statesText = this.incompleteLabel;
    } else {
      statesText = this.inCorrectLabel;
    }
    
    return statesText;
  }

  convertDateToDisplay(date: string): string{
    var testDate = date.substring(0,date.indexOf('T'));
    testDate = testDate.replace(/-/g,"/");
    return testDate;
  }
  countCorrect(tasks){
    let correct = 0;
    for (const task of tasks) {
      if (task.status === 0 || task.status === 4 ) {
        ++correct;
      }
    }
    return correct;

  }

  countResponse(tasks, isSkipCount): number {
    let count = 0;
    for (const task of tasks) {
      if (isSkipCount) {
        if (task.status === 2 || task.status === 3 ) {
          ++count;
        }
      } else {
        if (task.status === 1 || task.status === 5 || task.status === 6 || task.status === 7 || task.status === 8 ) {
          ++count;
        }
      }
    }
    return count;
  }
  convertTime(input, separator) {
    return [
      this.pad(Math.floor(input / 3600)),
      this.pad(Math.floor(input % 3600 / 60)),
      this.pad(Math.floor(input % 60)),
    ].join(typeof separator !== 'undefined' ? separator : ':');
  }
  pad(input) { return input < 10 ? '0' + input : input; }
  fillDataInJson(data, skillId) {
    this.attemptlist = [];
    let sumCorrect = 0, totalQuestion = 0;
    for (const attempt of data.skillAttemptList) {
      const taskListData = this.getTaskListData(attempt.strataExamResult.questions.question, skillId);
      const attemptData: TaskAttemptList = {
        timeLimit: attempt.timeLimit,
        testDateTime: attempt.testDateTime,
        timeUsed: attempt.timeUsed,
        itemsCorrect: attempt.itemsCorrect,
        totalScore: attempt.score,
        totalItems: attempt.totalItems,
        hasClickStream: taskListData.pop(),
        taskList: taskListData
      };
      sumCorrect += attempt.itemsCorrect;
      totalQuestion += attempt.totalItems;
      this.attemptlist.push(attemptData);
    }
    this.userName = data.userName;
    if (!this.isDashboard) {
      if (totalQuestion === 0 || sumCorrect === 0) {
        this.itemValue = 0;
      } else {
        this.itemValue = sumCorrect / totalQuestion;
      }
      this.pieChartType = this.getPieChartType(this.itemValue);
    }
  }

  getAttemptListBySkillId( data, skillId ) {
    const attemptList = [];

    for (const attempt of data.skillAttemptList) {
      const taskListData = this.getTaskListData(attempt.strataExamResult.questions.question, skillId);
      const attemptData: TaskAttemptList = {
        timeLimit: attempt.timeLimit,
        testDateTime: attempt.testDateTime,
        timeUsed: attempt.timeUsed,
        itemsCorrect: attempt.itemsCorrect,
        totalScore: attempt.score,
        totalItems: attempt.totalItems,
        hasClickStream: taskListData.pop(),
        taskList: taskListData
      };
      attemptList.push(attemptData);
    }

    return attemptList;
  }

  getTaskListData(taskList, skillId) {
    const trainingTaskList = this.getTaskListOfSkill(skillId).taskList;
    const taskListArray = [];
    var hasClickstream = false;
    for (const task of taskList) {
      const taskData = trainingTaskList.find(record => record.questionId === task.id);
      const taskListData: TaskListFullModel = {
        taskName: taskData.taskName,
        taskId: task.id,
        questionId: taskData.questionId,
        status: task.sts,
        timeTaken: task.tt,
        clickstreams: task.clickstreams.clickstream
      };
      if(taskListData.clickstreams.length > 0)
      {
        hasClickstream = true;
      }
      taskListArray.push(taskListData);
    }
    taskListArray.push(hasClickstream);
    return taskListArray;
  }
  getTaskListOfSkill(skillId) {
    const taskList = MainComponent.getTrainingList().find(record => record.skillId === skillId);
    return taskList;
  }
  fillHeader() {
    for (const headerTitle of this.tableHeaderCols) {
      this.header.push(new Table(Types.TEXT, 'table-header', headerTitle));
    }
  }
  getAutoTrainingCodeList(activeStatus) {
    const clientId = this.isReviewMode ? this.reviewCandidateId : this.currentUserClientID;
    this.getDataFromApi(this.getATCListEndPoint, { clientId, active: activeStatus })
      .subscribe(
        this.handleATCListData.bind(this),
        this.handleSubscriptionError.bind(this, this.getAutoTrainingCodeList.bind(this), false)
      );
  }
  handleATCListData(data) {
    this.hideLoader();
    MainComponent.setAtcData(data);
  }
  getClientTrainingList() {
    this.getDataFromApi(this.getClientTrainingListEndPoint, { clientId: this.currentUserClientID, systemId: this.systemID })
      .subscribe(
        this.handleClientTrainingListData.bind(this),
        this.handleSubscriptionError.bind(this, this.getClientTrainingList.bind(this), false)
      );
  }

  handleClientTrainingListData(data) {
    this.hideLoader();
    MainComponent.setTrainingList(data.trainingList);
  }

  // shows the dialog modalInfo contains the info which we want to show in the modal component
  showDialog(modalInfo: {
    title: string
    body: string
  }, onCloseSuccess?: Function) {
    this.dialogSuccessCallback = null;
    if (onCloseSuccess) {
      this.dialogSuccessCallback = onCloseSuccess;
    }
    this.modalData = modalInfo;
    this.dialogVisible = true;
  }

  // hides the dialog
  hideDialog(isSuccessCallbackCalled?) {
    if (isSuccessCallbackCalled && this.dialogSuccessCallback !== null) {
      this.dialogSuccessCallback();
    }
    this.modalData = {
      title: '',
      body: ''
    };
    this.dialogVisible = false;
    this.retryPopup = false;
    this.validationPopup = false;
    this.progressPopup = false;
  }

  showLoader() {
    EngineComponent.showLoader();
  }

  hideLoader() {
    EngineComponent.hideLoader();
  }

  prepareDataForCreateAtc(atcInSelectList: Array<SelectListTypeForCreation>, defaultTime?): Array<TrainingsInAutoTrainingCodeModel> {
    const arrAutoTrainingCodeList: Array<TrainingsInAutoTrainingCodeModel> = [];
    atcInSelectList.forEach((atc, index) => {
      const atcModel: TrainingsInAutoTrainingCodeModel = {
        assignment: atc.assignment,
        skill: atc.skill,
        skillId: atc.skillId,
        application: atc.application,
        taskCount: atc.taskList.length,
        trainingOrder: index + 1,
        timeLimit: defaultTime * 60 || null
      };
      arrAutoTrainingCodeList.push(atcModel);
    });
    return arrAutoTrainingCodeList;
  }

  prepareDataForEditAtc(atcInSelectList: Array<SelectListTypeForEdit>, defaultTime): Array<TrainingsInAutoTrainingCodeModel> {
    const arrTrainingsInAtc: Array<TrainingsInAutoTrainingCodeModel> = [];
    atcInSelectList.forEach((atc, index) => {
      if (atc.autoTrainingCode === undefined) {
        atc.autoTrainingCode = (atc as any);
      }
      const atcFullModel: TrainingsInAutoTrainingCodeModel = {
        trainingsInAutoTrainingCodeId: atc.autoTrainingCode.trainingsInAutoTrainingCodeId || '',
        assignment: atc.autoTrainingCode.assignment,
        skill: atc.autoTrainingCode.skill,
        skillId: atc.autoTrainingCode.skillId,
        application: atc.autoTrainingCode.application,
        taskCount: atc.autoTrainingCode.taskCount,
        timeLimit: atc.autoTrainingCode.timeLimit || defaultTime * 60,
        trainingOrder: atc.autoTrainingCode.trainingOrder || index + 1
      };
      arrTrainingsInAtc.push(atcFullModel);
    });
    return arrTrainingsInAtc;
  }

  protected handleSubscriptionError(failedFunction, isPostRequest: boolean, error) {
    let dataForDialog = { title: '', body: '' };
    let popupTitleKey = 'serverErrorTitle';
    let popupBodyKey = 'serverErrorData';
    if (error.status === 401) {
      this.loginService.startSilentRenew();
      popupTitleKey = 'genericServerError';
      popupBodyKey = '401ErrorMessage';
    }
    if (error.status === 500) {
      dataForDialog = {
        title: this.stringTableService.getString('popupMessages', 'genericServerError'),
        body: error.error.response
      };
    } else {
      dataForDialog = {
        title: this.stringTableService.getString('popupMessages', popupTitleKey),
        body: this.stringTableService.getString('popupMessages', popupBodyKey)
      };
    }
    this.hideLoader();
    if (isPostRequest) {
      this.retryPopup = (error.status === 500 || error.status === 404) ? false : true;
      this.validationPopup = !this.retryPopup;
      failedFunction = new Function();
    } else {
      this.retryPopup = true;
    }
    this.showDialog(dataForDialog, () => {
      this.retryPopup = false;
      this.validationPopup = false;
      failedFunction();
    });
  }

  handlePrintClicked() {
    window.print();
  }

  // Formatting date coming from API.
  protected formatDate(d) {
    if (d === null || d.length === 0) {
      return '';
    }
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [month, day, year].join('/');
  }

  // Date conversion to iso format to support date comparisons of dates from date picker and date coming from API in cross browsers
  protected dateConversion(dateString): Date {
    if (dateString === null || dateString === undefined || dateString.length === 0 || dateString === '0001-01-01T00:00:00') {
      return null;
    }
    const regEx = RegExp('(^\\d+-\\d+-\\d+)|(^\\d+\/\\d+\/\\d+)');
    const matchedDate = regEx.exec(dateString);
    let newDate = null;
    if (matchedDate) {
      newDate = new Date(matchedDate[0]);
    }
    return newDate;
  }

  avoidSpace(event) {
    if (event.charCode === KeyCodes.space) {
      event.preventDefault();
    }
  }

  validateTextboxLength(textBox, checkMaxLength) {
    const minLength = 1;
    const maxLength = 50;
    if (textBox.checkMinLength(textBox.getInputLength(), minLength)) {
      if (checkMaxLength) {
        if (textBox.checkMaxLength(textBox.getInputLength(), maxLength)) {
          return true;
        } else {
          this.validationString = textBox.strPlaceholder + this.stringTableService.getString('popupMessages', 'textLengthValidation');
        }
      } else {
        return true;
      }
    } else {
      this.validationString = this.stringTableService.getString('popupMessages', 'textRequiredValidation') + textBox.strPlaceholder;
    }
    this.validationDialogCallback(this.validationString, '');
    textBox.setFocus();
    return false;
  }

  validateInputChar(textBox) {
    const regex = /\\|\//g;
    if (!regex.test(textBox.text)) {
      return true;
    }
    this.validationString = textBox.strPlaceholder + this.stringTableService.getString('popupMessages', 'specialCharacterValidation');
    this.validationDialogCallback(this.validationString, '');
    return false;
  }

  validateEmail(emailString) {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regex.test(emailString)) {
      return true;
    } else {
      this.validationString = this.stringTableService.getString('popupMessages', 'emailValidation');
    }
    this.validationDialogCallback(this.validationString, '');
    return false;
  }

  validatePassword(password) {
    const lowerCaseRegex = /[a-z]/;
    const upperCaseRegex = /[A-Z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[\W_]/;
    let validationTitle = '';
    if (password.length >= 8 && lowerCaseRegex.test(password) && upperCaseRegex.test(password)
      && numberRegex.test(password) && specialCharRegex.test(password)) {
      return true;
    } else {
      this.validationString = this.stringTableService.getString('popupMessages', 'passwordValidation');
      validationTitle = this.stringTableService.getString('popupMessages', 'invalidPasswordTitle');
    }
    this.validationDialogCallback(validationTitle, this.validationString);
    return false;
  }

  validationDialogCallback(dialogTitle, dialogBody) {
    const dataForDialog = {
      title: dialogTitle,
      body: dialogBody
    };
    this.validationPopup = true;
    this.showDialog(dataForDialog, () => { this.validationPopup = false; });
  }

  protected prapareDataForSelectList(accordion: AccordionComponent) {
    const selectedIDs = [];
    const selectedAccordionNodes = [];
    for (const item of accordion.selectedItems) {
      selectedIDs.push(item.id);
    }
    for (const item of accordion.nodes) {
      for (const node of (item as any).nodes) {
        for (const subNodes of node.nodes) {
          if (selectedIDs.indexOf(subNodes.id) !== -1 ||
              selectedIDs.indexOf(subNodes.id.substring(0, subNodes.id.indexOf('.'))) !== -1 ||
              selectedIDs.indexOf(subNodes.id.substring(0, subNodes.id.lastIndexOf('.'))) !== -1) {
            subNodes.isSelect = false;
            subNodes.title = subNodes.assignment;
            selectedAccordionNodes.push(subNodes);
          }
        }
      }
    }
    return selectedAccordionNodes;
  }

  isDuplicateTest(event) {
    let assignmentName: String = '';
    for (let i = 0; i < event.data.length; i++) {
      if (i < event.data.length - 2) {
        assignmentName += event.data[i].skill + ', ';
      } else if (i < event.data.length - 1) {
        assignmentName += event.data[i].skill + ' and ';
      } else {
        assignmentName += event.data[i].skill + ' ';
      }
    }
    const dataForDialog = {
      title: assignmentName + this.stringTableService.getString('popupMessages', 'trainingAlreadyPresentTitle'),
      body: ''
    };
    if (event.data.length > 1) {
      dataForDialog.title = assignmentName + this.stringTableService.getString('popupMessages', 'trainingAlreadyPresentTitlePlural');
    }
    this.validationPopup = true;
    this.showDialog(dataForDialog, () => { this.validationPopup = false; });
  }

  getDateData(dateObj) {
    let date = dateObj.value;
    const isDateValid = dateObj.valid;
    if (dateObj.value === '') {
      date = null;
    }
    return { date: date, isDateValid: isDateValid };
  }

  dateValidation(startDate, endDate): boolean {
    if (this.isDateValid(startDate)) {
      if (this.isDateValid(endDate)) {
        if (this.checkEndDateGreater(startDate.date, endDate.date)) {
          return true;
        } else { this.validationString = this.stringTableService.getString('popupMessages', 'dateGreaterValidation'); }
      } else { this.validationString = this.stringTableService.getString('popupMessages', 'endDateValidation'); }
    } else { this.validationString = this.stringTableService.getString('popupMessages', 'startDateValidation'); }
    this.validationDialogCallback(this.validationString, '');
    return false;
  }

  optionalDateValidation(startDate, endDate): boolean {
    if (startDate.date == null || endDate.date == null) {
      return true;
    }

    if (this.checkEndDateGreater(startDate.date, endDate.date)) {
      return true;
    }

    this.validationString = this.stringTableService.getString('popupMessages', 'dateGreaterValidation');
    this.validationDialogCallback(this.validationString, '');
    return false;
  }

  isDateValid(dateObj): boolean {
    if (dateObj.date !== null && dateObj.isDateValid === true) {
      return true;
    }
    return false;
  }

  checkEndDateGreater(startDate, endDate): boolean {
    if (startDate !== null && endDate !== null) {
      if (this.changeDPDateFormat(startDate) > this.changeDPDateFormat(endDate)) {
        return false;
      }
    }
    return true;
  }

  // change format of date coming from datepicker
  changeDPDateFormat(dateString): Date {
    const reg = new RegExp('/', 'g');
    const res = dateString.replace(reg, '-');
    const date = this.dateConversion(res);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  selectBoxValidation(list) {
    if (list.getList().length !== 0) {
      return true;
    }
    this.validationString = this.stringTableService.getString('popupMessages', 'trainingsRequired');
    this.validationDialogCallback(this.validationString, '');
    return false;
  }

  loadHome() {
    this.router.navigate(['home']);
  }

  protected setDialogType(type: dialogTypeEnum) {
    switch (type) {
      case dialogTypeEnum.default:
        this.dialogType = type; break;
      case dialogTypeEnum.progressPopup:
        this.dialogType = type; break;
      case dialogTypeEnum.retryPopup:
        this.dialogType = type; break;
      case dialogTypeEnum.validationPopup:
        this.dialogType = type; break;
      case dialogTypeEnum.question:
        this.dialogType = type; break;
    }
  }
}


export enum qstnResponseStatus {
  Correct = 0,
  Incorrect = 1,
  Skipped = 2,
  Incomplete = 3
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/page-view/page-view.component.ts